import * as React from "react";
import { usePopper } from "react-popper";
import styled from "styled-components";
import Link from "../link/link";
import { DefaultFontStack } from "../typography/typography";

const Trigger = styled.button`
  all: unset;
  ${DefaultFontStack}
  color: ${(props) => props.theme.colors.highEmphasis};
  font-size: 17px;
  line-height: 30px;
  letter-spacing: 0.5px;
  font-size: 14px;
  padding: 10px 20px;
  border-radius: 10px;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.mediumEmphasis};
`;

const Popover = styled.div`
  ${DefaultFontStack}
  position: relative;
  z-index: 10;
  background-color: ${({ theme }) => theme.colors.day};
  visibility: hidden;
  border: 1px solid ${({ theme }) => theme.colors.silver};
  border-radius: 5px;
  overflow: hidden;
  box-shadow:
    0 10px 15px -3px rgb(0 0 0 / 0.1),
    0 4px 6px -4px rgb(0 0 0 / 0.1);
`;

const PopoverContent = styled.div`
  ${DefaultFontStack}
  display: flex;
  gap: 75px;
  padding: 40px 30px;
`;

const PopoverFooter = styled.div`
  ${DefaultFontStack}
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.ice};
  height: 40px;
  padding: 0px 40px;
`;

const Category = styled.div`
  ${DefaultFontStack}
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const CategoryHeading = styled.span`
  ${DefaultFontStack}
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mediumEmphasis};
`;

const CategoryHeadingLink = styled(Link)`
  all: unset;
  ${DefaultFontStack}
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.mediumEmphasis};
  cursor: pointer;
`;

const CategoryDivider = styled.div`
  ${DefaultFontStack}
  background-color: ${({ theme }) => theme.colors.awesome};
  height: 2px;
  width: 100%;
`;

const CategoryLink = styled(Link)`
  all: unset;
  display: flex;
  align-items: center;
  gap: 5px;
  ${DefaultFontStack}
  font-size: 17px;
  line-height: 30px;
  letter-spacing: 0.5px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.highEmphasis};
  cursor: pointer;
`;

const FooterLink = styled(Link)`
  all: unset;
  cursor: pointer;
  ${DefaultFontStack}
  font-size: 14px;
  color: ${({ theme }) => theme.colors.awesome};
`;

const Root = styled.div`
  ${DefaultFontStack}
  &:hover > ${Trigger} {
    background-color: ${({ theme }) => theme.colors.ice};
  }

  &:hover > ${Popover} {
    visibility: visible;
  }
`;

const NewTag = styled.span`
  ${DefaultFontStack}
  background-color: ${({ theme }) => theme.colors.awesome};
  color: white;
  padding: 2px 5px;
  border-radius: 40px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  line-height: 1;

  display: flex;
`;

const GroupContainer = styled.div`
  display: flex;
  gap: 50px;
`;

const GroupItems = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

function NavigationDropdown(props) {
  const { item } = props;

  const [referenceElement, setReferenceElement] = React.useState(null);
  const [popperElement, setPopperElement] = React.useState(null);
  const { styles, attributes } = usePopper(referenceElement, popperElement, {
    modifiers: [
      {
        name: "preventOverflow",
        options: {
          padding: 10,
        },
      },
    ],
  });

  return (
    <Root data-component-name="navigation-dropdown">
      <Trigger ref={setReferenceElement}>{item.text}</Trigger>
      <Popover
        ref={setPopperElement}
        style={styles.popper}
        {...attributes.popper}
      >
        <PopoverContent>
          {item.dropdownItems.map((category) => (
            <Category key={category.text}>
              {category.url !== undefined ? (
                <CategoryHeadingLink url={category.url}>
                  {category.text}
                </CategoryHeadingLink>
              ) : (
                <CategoryHeading>{category.text}</CategoryHeading>
              )}
              <CategoryDivider />
              <GroupContainer>
                {category.linkItems.map((group, idx) => (
                  <GroupItems key={idx}>
                    {group.map((link) => (
                      <CategoryLink key={link.text} url={link.url}>
                        {link.text} {link.new ? <NewTag>New</NewTag> : null}
                      </CategoryLink>
                    ))}
                  </GroupItems>
                ))}
              </GroupContainer>
            </Category>
          ))}
        </PopoverContent>
        <PopoverFooter>
          <FooterLink url="https://www.vorne.com/products/free-trial/">
            Try Vorne XL free for 90 days
          </FooterLink>
        </PopoverFooter>
      </Popover>
    </Root>
  );
}

export default NavigationDropdown;
